import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { User } from '../../users/user.interface';
import { UserService } from './user.service';

const service = new UserService();

export interface UserState {
   usersOverview?: ApiResource<Array<User>>;
}

const UserStore: Module<UserState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_USERS_OVERVIEW(state, usersOverview?: ApiResource<Array<User>>) {
         state.usersOverview = usersOverview;
      },
      ADD_USER(state, user: User) {
         state.usersOverview?.data.push(user);
      },
      DELETE_USER(state, userId: number) {
         const index = (state.usersOverview?.data || []).findIndex((u) => u.id === userId);
         if (index > -1) state.usersOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getUsers(context, payload: { teamId: number; query?: LocationQuery }) {
         const response = await service.getUsers(payload.teamId, payload.query);
         context.commit('SET_USERS_OVERVIEW', response);
         return response;
      },
      async addUsersToTeam(context, payload: { teamId: number; users: Array<User> }) {
         const response = await service.postUsersBatch(payload.teamId, payload.users);

         response.forEach((user) => {
            context.commit('ADD_USER', user);
         });

         return response;
      },
      async removeUsersFromTeam(context, payload: { teamId: number; users: Array<User> }) {
         const response = await service.deleteUsersBatch(payload.teamId, payload.users);
         response.forEach((userId) => {
            context.commit('DELETE_USER', userId);
         });

         return response;
      },
   },
};

export default UserStore;
